<template>
  <div class="container">
    <PageTitle :title="'About me'" class="tl"></PageTitle>
    <div class="content">
     <p>Hi! My name is Siming, and I am a high school student studying in the UK. I've always had a keen interest in machine learning, and with all of the attention surrounding the upcoming US election, I thought it would be interesting to create a program that analyzes your voice and tells you whether you sound more like Biden or Trump.</p>
      Feel free to contact me if you are interested in my work! My email address is: <a href="mailto:simingrox@gmail.com">simingrox@gmail.com</a>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Title'
export default {
  name: 'About',
  components: { PageTitle },
  metaInfo: {
    title: 'About This Project'
  }
}
</script>

<style scoped>
  @import "../assets/css/static_content.css";
</style>



// WEBPACK FOOTER //
// src/view/AboutMe.vue